<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true">
  <div class="inyova-grow-fund-modal">
    <app-inyova-grow-deposit-widget
      *ngIf="showDepositWidget && growAccount.step_status === accountStatus.OPENED"
      [growAccount]="growAccount"
    ></app-inyova-grow-deposit-widget>

    <h3 class="ds-title-3">{{ fund.title }}</h3>

    <!-- project stage and status -->
    <div class="ds-rows-white">
      @if (fund.status !== projectStatus.INITIAL) {
        <div class="ds-row-white only-one-row">
          <div class="content">
            <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.project.customerInvestmentStatus.label' | translate }}</p>
            <div>
              <app-ds-badge [type]="getInvestmentBadge(fund.status).type">
                {{ 'GROW.project.customerInvestmentStatus.' + getInvestmentBadge(fund.status).key + '.name' | translate }}
              </app-ds-badge>
              <ion-icon name="info2" (click)="toggleInfo('status')"></ion-icon>
            </div>
          </div>

          <div *ngIf="showInfo['status']" class="info">
            <p class="ds-ui-3 ds-color-core-neutral-7">
              {{ 'GROW.MMF.customerInvestmentStatus.' + getInvestmentBadge(fund.status).key + '.infoText' | translate }}
            </p>
          </div>
        </div>
      }
    </div>

    <div class="inyova-grow-figures">
      <h2 class="ds-heading-2">{{ 'GROW.project.keyFigures' | translate }}</h2>
      <ng-container>
        <!-- interest rate -->
        <app-ds-info-row
          [title]="'GROW.project.figure.fundExpectedReturn' | translate"
          [value]="fund.expected_return | percent: '1.2'"
          [info]="'GROW.project.figureInfo.fundExpectedReturn' | translate"
        ></app-ds-info-row>
        <!-- Currency -->
        <app-ds-info-row
          [title]="'GROW.project.figure.fundCurrency' | translate"
          [value]="fund.fund_currency"
          [info]="'GROW.project.figureInfo.fundCurrency' | translate"
        ></app-ds-info-row>
        <!-- Assets class -->
        <app-ds-info-row
          [title]="'GROW.project.figure.assetClass' | translate"
          [value]="fund.asset_class"
          [info]="'GROW.project.figureInfo.assetClass' | translate"
        ></app-ds-info-row>
        <!-- Fund Manager -->
        <app-ds-info-row
          [title]="'GROW.project.figure.custodianBank' | translate"
          [value]="fund.custodian_bank"
          [info]="'GROW.project.figureInfo.custodianBank' | translate"
        ></app-ds-info-row>
      </ng-container>
    </div>

    <ng-container>
      <div class="inyova-grow-project-content">
        <div [innerHTML]="fund.description"></div>
        <h3>{{ 'GROW.project.documents.title' | translate }}</h3>
        <app-inyova-grow-project-doc
          [doc]="fund.annual_report"
          [title]="'GROW.project.fund.documents.annualReport' | translate"
        ></app-inyova-grow-project-doc>
        <app-inyova-grow-project-doc
          [doc]="fund.fact_sheet"
          [title]="'GROW.project.fund.documents.factSheet' | translate"
        ></app-inyova-grow-project-doc>
        <app-inyova-grow-project-doc
          [doc]="fund.key_information_document"
          [title]="'GROW.project.fund.documents.keyInformation' | translate"
        ></app-inyova-grow-project-doc>
        <app-inyova-grow-project-doc
          [doc]="fund.manager_document"
          [title]="'GROW.project.fund.documents.managersComment' | translate"
        ></app-inyova-grow-project-doc>
        <app-inyova-grow-project-doc
          [doc]="fund.prospectus"
          [title]="'GROW.project.fund.documents.prospectus' | translate"
        ></app-inyova-grow-project-doc>
      </div>
    </ng-container>
  </div>
</ion-content>
<ion-footer>
  <div class="inyova-grow-project-action">
    <app-ds-button (clicked)="onDismiss()" *ngIf="!isPerformancePage">
      {{ 'GROW.project.buttons.backToProjects' | translate }}
    </app-ds-button>
  </div>
</ion-footer>
